import React from 'react';
import { CommonEmbed } from 'components/common/CommonEmbed';

export const FAQ: React.FC = () => {
    return <CommonEmbed title="FAQ" path="/faq" />;
};
